import { createIconComponent } from './createIconComponent';
import { ReactComponent as Icon } from './resources/arrowRight.svg';

export const IconArrowRight = createIconComponent(Icon);
